export default __webpack_public_path__ + "static/media/placeholder_dummy2016-psychotherapie01-mobile-de.02c8aab8.png";